import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
//import 'react-pdf/dist/esm/Page/AnnotationLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc =
  `${process.env.PUBLIC_URL}/pdf.worker.min.js`;
// pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//     'pdfjs-dist/build/pdf.worker.min.js',
//     import.meta.url
// ).toString();

const TestPdfViewer = () => {
    const [file, setFile] = useState(null);
    const [numPages, setNumPages] = useState(null);
    const [error, setError] = useState(null);

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        console.log("📄 Selected File:", selectedFile);
        setFile(selectedFile);
        setError(null);
    };

    return (
        <div style={{ padding: '20px' }}>
            <h2>PDF Preview Test</h2>
            <input
                type="file"
                accept="application/pdf"
                onChange={handleFileChange}
            />
            {file && (
                <Document
                    file={file}
                    onLoadSuccess={({ numPages }) => {
                        console.log(`✅ Loaded PDF with ${numPages} pages`);
                        setNumPages(numPages);
                    }}
                    onLoadError={(error) => {
                        console.error("❌ Failed to load PDF:", error);
                        setError(error.message || "Unknown error");
                    }}
                >
                    <Page pageNumber={1} width={600} />
                </Document>
            )}
            {error && <div style={{ color: 'red' }}>❌ {error}</div>}
        </div>
    );
};

export default TestPdfViewer;
